
//  import UGlobalService from '@/model/UGlobalService.js'


// 等待状态
const ULRECORDREADY = 0

// 检查权限中
const ULRECORDCHECK = 1
// 录音中
const ULRECORDING = 2
// 录音结束
const ULRECORDEND = 3
// 检查权限拒绝
const ULRECORDDENY = 4

class Record {
  constructor () {
    // 录音的状态
    this.status = ULRECORDREADY
    // 文件路径
    this.filePath = ''
    // 当前声音时长
    this.currentDuration = 0
    // 录音最大时长
    this.durationLimit = 300
    // 定时器
    this._timer = {}

    this.onBeforeStartRecord = function () {}
    this.startRecord = function (success, failure, durationChange) {
      if (this.filePath) {
        this.filePath = ''
        this.status = ULRECORDREADY
      }
      // if (this.status !== ULRECORDREADY) {
      //   // 正在录音中，稍后重试
      //   failure && failure('正在录音请稍后重试')
      //   return
      // }
      // 状态切换为检查中
      this.status = ULRECORDCHECK
      this.onDurationChange = durationChange
      let _this = this
      window.ULplugin.URecorder.onStartRecord = function () {
        _this.onBeforeStartRecord && _this.onBeforeStartRecord()
        _this.status = ULRECORDING
        _this.currentDuration = 0
        _this._timer = setInterval(function () {
          if (_this.currentDuration >= _this.durationLimit) {
            window.ULplugin.URecorder.stopRecord()
            return
          }

          //  不录音时，或者时间超过限制，停止计时，停止录音
          if (_this.status === ULRECORDREADY || _this.status === ULRECORDEND || _this.currentDuration >= _this.durationLimit) {
            _this.stopRecord()
            clearInterval(_this._timer)
            return
          }
          _this.currentDuration++
          _this.onDurationChange && _this.onDurationChange(_this.currentDuration)
        }, 1000)
      }
      window.ULplugin.URecorder.onRecordComplete = function (filePath) {
        _this.status = ULRECORDEND
        _this.filePath = filePath
        if (this._timer) {
          clearInterval(this._timer)
        }
        _this.onRecordCompleteSuccess && _this.onRecordCompleteSuccess(filePath, _this.currentDuration)
        _this.currentDuration = 0
      }
      window.ULplugin.URecorder.checkPermission(() => {
        //  权限允许
        success && success()
        window.ULplugin.URecorder.startRecord()
      }, (msg) => {
        _this.status = ULRECORDDENY
        failure && failure(i18n.t('请打开手机权限'))
        //  权限拒绝
      })
    }

    this.stopRecord = function () {
      // this.status = ULRECORDREADY
      window.ULplugin.URecorder.stopRecord()
    }
    this.clearRecord = function () {
      this.status = ULRECORDREADY
      this.filePath = ''
      this.currentDuration = 0
      this.stopRecord()
    }
    // 录音完成的回调
    this.onRecordCompleteSuccess = function () {}

    this.onDurationChange = function () {}
  }
}

// class Media {
//   constructor () {
//     // 图片查看
//     this.imgPreview = function (imgpath) {
//       window.ULplugin.UFile.imgPreview(imgpath)
//     }
//     // 打开文档
//     this.openFileInOtherApp = function (path) {
//       window.ULplugin.UFile.openFileInOtherApp(path)
//     }
//     // 打开视频
//     this.openVideo = function (path) {
//       window.ULplugin.UMedia.playVideo(path)
//     }
//   }
// }

// export function creatMedia () {
//   return new Media()
// }

/***
 *录音对象
 */
export function creatRecord () {
  return new Record()
}

// /*
//  * 退出App
//  * */
// export function exitApp () {
//   if (window.ULplugin) {
//     window.ULplugin.UApp.finish()
//   }
// }

// // 打开外部连接带导航栏
// export function openUrl (url, external) {
//   window.ULplugin.UApp.openUrl(url, external)
// }

// 更新活动列表通知
export function updateActiveList () {
  
  window.broadcaster.fireNativeEvent(UGlobalService.getRefreshNotice(), {}, function () {})
  window.broadcaster.fireNativeEvent(UGlobalService.getRefreshHomework(), {}, function () {})
}

class MobileUploder {
    constructor () {
      this.manger = {}
      // let self = this
      this.uploadFile = function(filePath, progress, success, failure) {
       window.ULplugin.UUploader.uploadFile(filePath, progress, success, failure)
    }
      // this.uploadFile = function (filePath, progress, success, failure) {
      //   if (this.manger[filePath]) return
      //   let model = {}
      //   model.progress = progress
      //   model.success = success
      //   model.failure = failure
      //   this.manger[filePath] = model
      //   window.ULplugin.UUploader.onUploadProgress = function (filePath, progress) {
      //     let model = self.manger[filePath]
      //     if (model) {
      //       model.progress && model.progress(progress)
      //     }
      //   }
      //   window.ULplugin.UUploader.onUploadCancel = function (filePath) {
      //     let model = self.manger[filePath]
      //     if (model) {
      //       model.cancelSuccess && model.cancelSuccess()
      //     }
      //   }
      //   window.ULplugin.UUploader.onUploadSuccess = function (filePath, remotePath) {
      //     let model = self.manger[filePath]
      //     if (model) {
      //       remotePath = remotePath.replace(commonParams.QINIU_RESOURCE_URL, '')
      //       remotePath = remotePath.replace('http://leicloud.qiniudn.com/', '')
      //       remotePath = remotePath.replace('http://tskcloud.qiniudn.cn/', '')
      //       let richFileArr = ['doc', 'pdf', 'ppt', 'xls']
      //       let originType = formatLimit(filePath)
      //       if (richFileArr.indexOf(originType) > -1) {
      //         // 文档--- 转换
      //         Convert.getConvertFile(remotePath)
      //       } else if (originType === 'video') {
      //         // 视频 --转换
      //         Convert.getConvertVideo(remotePath)
      //       }
      //       model.success && model.success(filePath, remotePath)
  
      //       delete self.manger[filePath]
      //     }
      //   }
      //   window.ULplugin.UUploader.onUploadFail = function (filePath) {
      //     let model = self.manger[filePath]
      //     if (model) {
      //       model.failure && model.failure()
      //     }
      //   }
      //   window.ULplugin.UUploader.upload(filePath)
      // }
      this.cancelUpload = function (filePath, success) {
        if (!this.manger[filePath]) return
        let model = this.manger[filePath]
        model.cancelSuccess = success
      }
    }
  }
  
  export function createUploader () {
    return new MobileUploder()
  }
  
  // class MobileDownloader {
  //   constructor () {
  //     this.downloadObj = {}
  //     // 检查远程文件的本地是否下载成功
  //     this.checkFileLocalPath = function (path, success, failure) {
  //       window.ULplugin.UFile.isExist(path, success, failure)
  //     }
  //     this.openFileInOtherApp = function (path) {
  //       window.ULplugin.UFile.openFileInOtherApp(path)
  //     }
  //     this.openVideo = function (path) {
  //       window.ULplugin.UMedia.playVideo(path)
  //     }
  //     // 检查网络状态
  //     this.checkNetworkStatus = function (success) {
  //       // 1、是wifi 2、是移动网 3、无网络
  //       window.ULplugin.UApp.networkState((status) => {
  //         success(status)
  //       })
  //     }
  //     // 开始下载
  //     this.download = function (path, progress, complete, failure) {
  //       this.addEventListener(path, progress, complete, failure)
  //       path = this.formateDownLoadPath(path, progress, complete, failure)
  //       window.ULplugin.UFile.download(path)
  //     }
  //     this.cancel = function (path) {
  //       window.ULplugin.UFile.cancelDownload(path)
  //     }
  //     // 格式化下载的路径
  //     this.formateDownLoadPath = function (path, progress, complete, failure) {
  //       let suffixName = path.split('/').pop()
  //       let filename = suffixName.split('.')[0]
  //       // let Obj = this.downloadObj[path]
  //       // if (!Obj) {
  //       //   this.downloadObj[path] = {
  //       //     path: path,
  //       //     name: suffixName,
  //       //     progressFns: [progress],
  //       //     completeFns: [complete],
  //       //     failureFns: [failure]
  //       //   }
  //       // } else {
  //       //   progress && Obj.progressFns.push(progress)
  //       //   complete && Obj.completeFns.push(complete)
  //       //   failure && Obj.failureFns.push(failure)
  //       // }
  //       return `${path}?name=${filename}`
  //     }
  //     // 添加事件监听，关闭页面，后台正在下载，注册监听方法，可以正确更新文件产状态
  //     this.addEventListener = function (path, progress, complete, failure) {
  //       let self = this
  //       let Obj = self.downloadObj[path]
  //       if (Obj) {
  //         Obj.progressFns.push(progress)
  //         Obj.completeFns.push(complete)
  //         Obj.failureFns.push(failure)
  //       } else {
  //         let suffixName = path.split('/').pop()
  //         this.downloadObj[path] = {
  //           path: path,
  //           name: suffixName,
  //           progressFns: [progress],
  //           completeFns: [complete],
  //           failureFns: [failure]
  //         }
  //       }
  //       window.ULplugin.UFile.onDownloadProgress = function (url, progress) {
  //         if (progress) {
  //           console.log(progress)
  //         }
  //         // console.log('我是进度更新了', url, progress)
  //         let Obj = self.downloadObj[url]
  //         if (Obj && Obj.progressFns && Obj.progressFns.length !== 0) {
  //           Obj.progressFns.forEach((item) => {
  //             if (progress) {
  //               item && item(progress)
  //             }
  //           })
  //         }
  //       }
  //       window.ULplugin.UFile.onDownloadError = function (url, errmsg) {
  //         let Obj = self.downloadObj[url]
  //         if (Obj && Obj.failureFns && Obj.failureFns.length !== 0) {
  //           Obj.failureFns.forEach((item) => {
  //             item && item(errmsg)
  //           })
  //         }
  //       }
  //       window.ULplugin.UFile.onDownloadSuccess = function (url, filePath) {
  //         let Obj = self.downloadObj[url]
  //         if (Obj && Obj.completeFns && Obj.completeFns.length !== 0) {
  //           Obj.completeFns.forEach((item) => {
  //             item && item(filePath)
  //           })
  //         }
  //       }
  //     }
  //   }
  // }
  
  // export function creatDownloader () {
  //   return new MobileDownloader()
  // }
  export function download (file) {
    window.FilePugin.download(file.filePath, function (filePath, progress, b, c) {
       // console.log('file process', progress, filePath, file)
        file.progress(progress)
    }, function (filePath, localFilePath) {}, function (filePath, error) {})
};
  export function playAudio (audioUrl, complete, durationChange) {
    window.ULplugin.UMedia.playAudio(audioUrl, complete, durationChange)
  }
  
  export function stopAudio () {
    window.ULplugin.UMedia.stopAudio()
  }
  
  import { formatFileType } from '@/utils/file'
  
  /**
   * getPicture Android 拍照
   * selectFileFromiOS
   * ios 拍照/选择相册/选择相册+视频
   * srcType = args.optInt(2, 1); 1拍照，2图库
   * mediaType = args.optInt(6, 0);  资源类型：0 照片 1视频 2照片+视频
   * saveToPhotoAlbum = args.optBoolean(9, false); 拍照图片是否保存到相册
   * cameraDirection	// 0 后置摄像头 1前置摄像头，默认1
   */
  export function getPictureFromMobile(success, fail, options) {
    //console.log("options",options);
    if (window.ULplugin && window.ULplugin.Camera) {
      if (options.isAndroid) {
        window.ULplugin.Camera.getPicture(res => {
          const arr = handelResult(res)
          success && success(arr)
        }, err => {
         // console.log(err)
          fail && fail('相册权限未打开')
        },options)
      } else {
        window.ULplugin.Camera.selectMediaFromPhotoAlbum(result => {
          const arr = handelResult(result)
          success && success(arr)
        }, err => {
          alert(err)
          fail && fail(err)
        }, options)
      }
    }
    function handelResult(result) {
      //console.log("handelResult",result);
      let arr = []
      if (result && result.length > 0) {
        let fileArr = result.split(',')
        fileArr.forEach((file) => {
          if (!/^file/.test(file)) {
            file = 'file://' + file
          }
          let fileName = file.split('/').pop().toString()
          arr.push({
            filePath: file,
            fileName: fileName,
            fileType: formatFileType(fileName)
          })
        })
      }
      return arr
    }
  } 
  export function fileSize(filePath,success,errorFn){
     if(window.FilePugin){
      window.FilePugin.fileSize(filePath, success,errorFn)
     }
  }
  
  // Android选择文件
  export function selectFileFromAndroid(success, fail, options) {
    var wordType = '*.doc;*.docx;*.xls;*.xlsx;*.pptx;*.ppt;*.pdf;*.txt;'
  var videoType = '*.mp4;*.avi;*.mov;*.flv;*.rmvb;*.mpg;'
  var audioType = '*.mp3;*.mov;'
  var picType = '.jpg;*.jpeg;*.png;*.gif;'
  var fileType = wordType + videoType + audioType + picType
  var fileSize = 200
    if (window.FilePugin) {
      //fileType, allFileSize, fileMaxCount, fizeSize
      window.FilePugin.selectFile(fileType,5000,options.maxCount,fileSize)
      window.onSelectedFiles = (fileCount, fileSize, fileArr) => {
        let arr = []
        if (fileArr && fileArr.length > 0) {
          let fileList = JSON.parse(fileArr)
          fileList.forEach((fileModel) => {
            if (fileModel.filepath && !/^file/.test(fileModel.filepath)) {
              let Obj = {}
              Obj.filePath = 'file://' + fileModel.filepath
              Obj.fileType = formatFileType(fileModel.filepath)
              Obj.fileSize = fileModel.length
              Obj.fileName = fileModel.filename
              arr.push(Obj)
            }
          })
        }
        success && success(arr)
      }
    }
  }
  // iOS选择文件(暂时文件大小，文件数量，文件类型无法限制，只能多选且任选)
  export function selectFileFromiOS(success, fail) {
    if (window.ULplugin && window.ULplugin.Camera) {
      window.ULplugin.Camera.selectFileFromiOS(result => {
        let arr = []
        if (result && result.length > 0) {
          let fileArr = JSON.parse(result)
          fileArr.forEach((file) => {
            if (!/^file/.test(file.filepath)) {
              file.filepath = 'file://' + file.filepath
            }
            arr.push({
              filePath: file.filepath,
              fileName: file.filename,
              fileType: formatFileType(file.filename)
            })
          })
        }
        success && success(arr)
      }, err => {
        alert(err)
        fail && fail(err)
      })
    }
  }
  
  /* 使用新版上传
    options = {
      module: 'discussion',
      userID: 1111
    }
   */
  export function UUploader(file, progress, success, error, cancel, options) {
    if (window.ULplugin && window.ULplugin.UUploader) {
      window.ULplugin.UUploader.uploadV1(file, (file, percent) => {
        progress && progress(file, percent)
      }, (file, filePath) => {
        success && success(file, filePath)
      }, (file, status) => {
        error && error(file, status)
      }, (file, percent) => {
        cancel && cancel(file, percent)
      }, options)
    }
  }
  export function cancelUpload(file) {
    if (window.ULplugin && window.ULplugin.UUploader) {
      window.ULplugin.UUploader.cancel(file)
    }
  }
  /*
   * 获取用户信息
   * */
  export function getUser(success) {
    if (window.ULplugin && window.ULplugin.User) {
      window.ULplugin.User.getUser(user => {
       // console.log(user)
        success && success(user)
      })
    }
  }
  /*
   * 退出App
   * */
  export function exitApp() {
    if (window.ULplugin) {
      window.ULplugin.UApp.finish()
    }
  }
  /*
   * 刷新作业列表
   * */
  export function refreshCourseHomework(){
    if (window.broadcaster) {
      window.broadcaster.fireNativeEvent("kLENotificationRefreshActivieList", {}, function () {});
      window.broadcaster.fireNativeEvent("UNotificationNameCourseHomeworkChange", {}, function () {});
    }
  }
  /*
   * 异地登录下线
   * */
  export function loggedOnOtherDevices(success, fail) {
    if (window.ULplugin && window.ULplugin.User) {
      window.ULplugin.User.loggedOnOtherDevices(() => {
        success && success()
      }, () => {
        fail && fail()
      })
    }
  }